/**
 *
 */
export const state = () => ({
    winter: [
        {
            name: 'all',
            isSelected: true,
            labelKey: 'activities.all',
            class: '',
        },
        {
            name: 'skiing',
            isSelected: false,
            labelKey: 'activities.skiing',
            class: '',
        },
        {
            name: 'tobogganing',
            isSelected: false,
            labelKey: 'activities.tobogganing',
            class: '',
        },
        {
            name: 'hiking',
            isSelected: false,
            labelKey: 'activities.hiking',
            class: '',
        },
    ],

    summer: [

    ],

});

export const mutations = {

    resetItems(state) {
        [...state.winter, ...state.summer].forEach((item) => {
            item.isSelected = false;
        });
        if (state.winter[0]) state.winter[0].isSelected = true;
        if (state.summer[0]) state.summer[0].isSelected = true;

    },

    selectItem(state, item) {
        [...state.winter, ...state.summer].forEach((i) => {
            i.isSelected = false;
        });
        item.isSelected = true;
    },
};

export const actions = {
    selectItem({ commit }, item) {
        commit('selectItem', item);
        commit('layerfilter/resetFilter', null, { root: true });
    },
};

export const getters = {
    items(state, otherGetters, rootState) {
        return state[rootState.currentSeason];
    },

    isSkiing(state, item) {
        return state.winter.find(i => i.name === 'skiing').isSelected;
    },
};
